export default __webpack_public_path__ + "static/media/youtube-logo.88aa5cf8.svg";